import * as React from 'react';

import styles from './OneOutlookSuiteHeader.scss';

type TitlebarProps = {
    title?: string;
};

export const Titlebar = React.memo((props: TitlebarProps) => {
    return (
        <div className={styles.titlebarContainer}>
            <div className={styles.titlebarText}>{props.title}</div>
        </div>
    );
});
